<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="depositAccountsFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#depositAccountsFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="title">
                                            {{ $t('label.title') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="title"
                                                dir="rtl"
                                                name="title"
                                                id="title"
                                                v-model="query.title"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="sheba">
                                            {{ $t('label.sheba_number') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                style="direction: ltr"
                                                id="sheba"
                                                name="sheba"
                                                v-model="query.sheba"
                                                class="form-control transfers_destination_number"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="account_number">
                                            {{ $t('label.account_number') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="account_number"
                                                dir="ltr"
                                                name="account_number"
                                                id="account_number"
                                                v-model="query.account_number"
                                        />
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-section>
                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>

import Inputmask from "inputmask";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    mounted() {
        this.initShebaMask();
    },
    methods: {
        initShebaMask() {
            Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.transfers_destination_number'));
        }
    },
    data() {
        return {
            query: {
            },
        }
    }
}
</script>

<style>

</style>